import React from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'
import { selectPostalCode } from 'src/modules/reducers/market'
import { useGetFDPreviewSlug } from 'src/modules/hooks/useGetFDPreviewSlug'

export default (props) => {
  const postalCode = useSelector(selectPostalCode)
  const { callsign, networkName, loadingText } = useGetFDPreviewSlug(postalCode)

  // Only create VideoObject structured data if callsign is available (geolocated)
  const videoStructuredData = callsign
    ? createVideoStructuredData({
        networkName: networkName || 'FanDuel Sports Network',
        callsign: callsign,
        logoUrl: networkLogos.fanduelsports.logoUrl,
        slug: 'fanduel-sports-network',
      })
    : null

  return (
    <>
      {videoStructuredData && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
        </Helmet>
      )}
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign={callsign}
        title="Watch FanDuel Sports Network live with Fubo"
        networkName={networkName}
        forceCallsign={true}
        loadingText={loadingText}
      />
    </>
  )
}
